import React from 'react';
import { HomeHero } from '../components/sections/home/Hero';
import { WhyMatters } from '../components/sections/home/WhyMatters';
import { CoreResponsibility } from '../components/sections/home/CoreResponsibility';
import { SupportingFamilies } from '../components/sections/home/SupportingFamilies';
import { ForAdults } from '../components/sections/home/ForAdults';
import { Partnering } from '../components/sections/home/Partnering';
import { GetInTouch } from '../components/sections/home/GetInTouch';
export function Home() {
  return <>
      <HomeHero data-id="element-3593" data-mp="24haivufz7kh9" />
      <WhyMatters data-id="element-3594" data-mp="24ivbvfmn6vd0" />
      <CoreResponsibility data-id="element-3595" data-mp="29gdc8hmlg29e" />
      <SupportingFamilies data-id="element-3596" data-mp="29f27oflbqqh8" />
      <ForAdults data-id="element-3597" data-mp="29etuemlahj5i" />
      <Partnering data-id="element-3598" data-mp="29ihphq6dudmc" />
      <GetInTouch data-id="element-3599" data-mp="2dhgs344n5yam" />
    </>;
}